import { Eye, Landmark, MoreHorizontal, Pencil } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { IStoreDeposit } from "src/@types/store-deposit-maintenance";

import { DEPOSIT_MAINTENANCE_LABELS } from "../types";

interface DepositRowActionsProps {
  readonly deposit: IStoreDeposit;
  readonly onEditNsu: (deposit: IStoreDeposit) => void;
  readonly onViewBankDetails: (deposit: IStoreDeposit) => void;
  readonly onEditAccount: (deposit: IStoreDeposit) => void;
}

export function DepositRowActions({
  deposit,
  onEditNsu,
  onViewBankDetails,
  onEditAccount,
}: DepositRowActionsProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost_none"
          className="flex h-8 w-8 p-0 data-[state=open]:bg-muted border-none bg-transparent"
        >
          <MoreHorizontal />
          <span className="sr-only">{DEPOSIT_MAINTENANCE_LABELS.openMenu}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[200px]">
        <DropdownMenuItem
          onClick={() => onEditNsu(deposit)}
          className="cursor-pointer"
        >
          <Pencil className="mr-2 h-4 w-4" />
          <span>{DEPOSIT_MAINTENANCE_LABELS.editNsuAction}</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onViewBankDetails(deposit)}
          className="cursor-pointer"
        >
          <Eye className="mr-2 h-4 w-4" />
          <span>{DEPOSIT_MAINTENANCE_LABELS.bankDetailsAction}</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onEditAccount(deposit)}
          className="cursor-pointer"
        >
          <Landmark className="mr-2 h-4 w-4" />
          <span>{DEPOSIT_MAINTENANCE_LABELS.editAccountAction}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
